export default __webpack_public_path__ + "static/media/kings-college-london.76f79ae9.svg";